import React from 'react';

const Label = ({ label, labelClassName }) => {
  return <div className={labelClassName || "custom-field-label"}>{label}</div>;
};

export default Label;